import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

import {
    Dialog, DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
  } from '@/components/ui/dialog'
  import {Button} from "@/components/ui/button";
  import TablesService from "@/services/tables/tables.service";
  import {cn, toast} from "@/utils/utils";
  import {i18n} from "@/utils/i18n";
  import {Check, ChevronsUpDown} from "lucide-vue-next";
  import {Popover, PopoverContent, PopoverTrigger} from "@/components/ui/popover";
  import {FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form";
  import {Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList} from "@/components/ui/command";
  import {Input} from "@/components/ui/input";
  import {onMounted, ref, watch} from "vue";
  import {toTypedSchema} from "@vee-validate/zod";
  import * as z from "zod";
  import {useForm} from "vee-validate";
  import axios from "axios";
  import {Category} from "@/models/tables/category.interface";
  import Spinner from "@/components/ui_custom/spinner/Spinner.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'UploadDocumentDialog',
  props: {
    entity: {},
    entityId: {},
    open: { type: Boolean },
    setOpen: {}
  },
  emits: ['edit'],
  setup(__props: any, { emit: __emit }) {

  const props = __props

  const emit = __emit
  const documents: any = ref([]);
  let document: any = {};
  const parentsOpen = ref(false);
  const categories = ref<Category[]>([]);
  const parents = ref([]);
  let isLoading = ref(false);
  const formSchema = toTypedSchema(z.object({
    file: z.any(),
    parentId: z.number(),
  }))

  const { handleSubmit, values, setValues } = useForm({
    validationSchema: formSchema,
  })

  const fetchCategories = async () => {
    const res = await axios.get(process.env.VUE_APP_BASE_API_URL + 'categories/tree', {
      headers: {
        Authorization: process.env.VUE_APP_API_KEY
      }
    });
    categories.value = res.data;
    parents.value = flattenCategories(res.data);
  };

  function flattenCategories(categories: any, level = 0): any {
    let result = [];
    for (const category of categories) {
      let flatCategory = {
        ...category,
        indentedName: `${'. '.repeat(level)}${category.name}`,
        level: level
      };
      result.push(flatCategory);
      if (category.children && category.children.length) {
        result = result.concat(flattenCategories(category.children, level + 1));
      }
    }
    return result;
  }

  watch(values, (newFormData) => {
    document = newFormData;
  });

  async function setFile(event: any) {
    const files = event.target.files ? event.target.files : null;
    for (const file of files) {
      const base64File = await convert(file);
      const blob = dataURLToBlob(base64File);

      documents.value.push({
        src: base64File,
        entityId: props.entityId,
        entity: props.entity,
        originalname: file.name,
        file: blob
      });
    }
  }

  function dataURLToBlob(dataUrl: any) {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  function convert(myFile: File): Promise<string | ArrayBuffer> {
    return new Promise<string | ArrayBuffer>((resolve, reject) => {
      const fileReader = new FileReader();
      if (fileReader && myFile) {
        fileReader.readAsDataURL(myFile);
        fileReader.onload = () => {
          resolve(fileReader.result as any);
        };

        fileReader.onerror = (error) => {
          reject(error);
        };
      } else {
        reject('No file provided');
      }
    });
  }

  const onSubmit = handleSubmit(async () => {
    isLoading.value = true;
    const formData = new FormData();
    formData.append('entity', props.entity.toString());
    formData.append('entityId', props.entityId.toString());
    formData.append('categoryId', document.parentId.toString());
    documents.value.forEach(function (document: any) {
      formData.append('files', document.file, document.originalname);
    })
    const res = await TablesService.createBulkAttachments(formData, 'attachments')
    if (res?.data.statusCode === 200) {
      toast.success(i18n.global.t('toast.insert_success'));
      emit('edit')
    }
    documents.value = [];
    isLoading.value = false;
  })

  onMounted(() => {
    fetchCategories();
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Spinner, { "is-loading": _unref(isLoading) }, null, 8, ["is-loading"]),
    _createVNode(_unref(Dialog), {
      open: props.open,
      "onUpdate:open": props.setOpen
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogContent), { class: "max-w-[60vw]" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('table.add')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("form", {
                  onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                  class: "mt-3"
                }, [
                  _createVNode(_unref(FormField), { name: "file" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FormItem), { class: "w-full" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('column.document')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormControl), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Input), {
                                multiple: "",
                                type: "file",
                                id: "file",
                                onChange: setFile
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormMessage))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormField), { name: "parentId" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FormItem), { class: "flex flex-col w-full" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('column.parent')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(Popover), {
                            open: parentsOpen.value,
                            "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((parentsOpen).value = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormControl), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Button), {
                                        variant: "outline",
                                        role: "combobox",
                                        class: _normalizeClass(_unref(cn)('w-full justify-between', !_unref(values).parentId && 'text-muted-foreground'))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(values).parentId ? parents.value.find(
                        (parentId) => parentId.id === _unref(values).parentId,
                    )?.name : _unref(i18n).global.t('table.select')) + " ", 1),
                                          _createVNode(_unref(ChevronsUpDown), { class: "ml-2 h-4 w-4 shrink-0 opacity-50" })
                                        ]),
                                        _: 1
                                      }, 8, ["class"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(PopoverContent), { class: "w-[45vw] p-0" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Command), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CommandInput), {
                                        placeholder: _ctx.$t('table.search')
                                      }, null, 8, ["placeholder"]),
                                      _createVNode(_unref(CommandEmpty), null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('table.no_result')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(CommandList), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CommandGroup), null, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parents.value, (parent) => {
                                                return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                  key: parent.id,
                                                  value: parent.id,
                                                  onSelect: () => {
                              _unref(setValues)({
                                parentId: parent.id,
                              })
                              parentsOpen.value = false
                            }
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(Check), {
                                                      class: _normalizeClass(_unref(cn)('mr-2 h-4 w-4', parent.id === _unref(values).parentId ? 'opacity-100' : 'opacity-0'))
                                                    }, null, 8, ["class"]),
                                                    _createTextVNode(" " + _toDisplayString(`${'- '.repeat(parent.level) }${parent.name}`), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["value", "onSelect"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["open"]),
                          _createVNode(_unref(FormMessage))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(DialogFooter), { class: "mt-6" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogClose), { "as-child": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Button), {
                            type: "button",
                            variant: "secondary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('table.cancel')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Button), { type: "submit" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('table.confirm')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 32)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open", "onUpdate:open"])
  ], 64))
}
}

})